export default "__VITE_ASSET__DZj5Voy9__"